/**
 * Shared payment rules for the Australian MVP Stripe marketplace.
 * Paid products are Creator/Organisation subscriptions and one-off Programs only,
 * and all marketplace pricing is in AUD.
 */

export const MARKETPLACE_CURRENCY = 'AUD';

export const ONE_MONTH_SUBSCRIPTION_REQUIRED = 'A one-month subscription option is required.';

/** Subscription plans come from master data; the one-month plan is named "1 Month". */
export function isOneMonthPlan(plan: any): boolean {
  if (!plan) { return false; }
  if (plan.duration_months !== undefined) { return Number(plan.duration_months) === 1; }
  return String(plan.name || '').trim().toLowerCase() === '1 month';
}

const STATUS_LABELS: { [status: string]: string } = {
  pending: 'Pending',
  processing: 'Pending',
  requires_action: 'Pending',
  succeeded: 'Paid',
  paid: 'Paid',
  complete: 'Paid',
  failed: 'Failed',
  requires_payment_method: 'Failed',
  canceled: 'Failed',
  refund_pending: 'Refund pending',
  refunded: 'Refunded',
  partially_refunded: 'Partially refunded',
  refund_failed: 'Refund failed',
  disputed: 'Disputed',
  dispute_won: 'Dispute won',
  dispute_lost: 'Dispute lost',
};

/** Human-readable label for a transaction's payment/refund/dispute state. */
export function transactionStatusLabel(txn: any): string {
  const status = String(txn?.txnStatus || '').trim().toLowerCase();
  if (!status) { return '-'; }
  return STATUS_LABELS[status] || status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
}

/** Distinguishes the initial subscription payment from a recurring renewal. */
export function transactionTypeLabel(txn: any): string {
  if (txn?.txnFor === 'Subscribe') {
    const isRenewal = txn.is_renewal === true || txn.billing_reason === 'subscription_cycle';
    return isRenewal ? 'Subscription renewal' : 'Subscription';
  }
  return txn?.txnFor || '-';
}

/** Title column: the plan (e.g. "3 Month") for subscriptions, the Program name otherwise. */
export function transactionTitle(txn: any): string {
  if (txn?.txnFor === 'Subscribe') {
    return txn.plan_name || txn.title || 'Subscription';
  }
  return txn?.title || '-';
}
